<template>
  <div class="exception">
    <div class="imgBlock">
      <div class="imgEle" :style="{backgroundImage: `url(${config[type].img})`}">
      </div>
    </div>
    <div class="content">
      <h1>{{ config[type].title }}</h1>
      <div class="desc">{{ description }}</div>
      <div class="actions" v-if="back">
        <a-button type="primary" @click="goBack">Go Back</a-button>
      </div>
    </div>
  </div>
</template>
<script>
import types from './type'

export default {
  // property
  props: {
    type: {
      type: String,
      default: '404'
    },
    message: {
      type: String,
      default: ''
    },
    back: {
      type: Boolean,
      default: true
    }
  },
  // computed property
  computed: {
    description() {
      return (this.message !== '') ? this.message : this.config[this.type].desc
    }
  },
  // data
  data() {
    return {
      config: types
    }
  },
  // event

  // methods
  methods: {
    goBack() {
      history.back()
    }
  }
}
</script>
